import "../styles/terms_and_conditions.css";
import CCLogoIcon from "../assets/Care_Concierge_Logo.png";
import FBLogoIcon from "../assets/facebook_icon.png";
import InstaLogoIcon from "../assets/instagram_icon.png";
import Divider from "./divider";


const Header = () => {
    return (
        <div>
            <div className="t-col-container">
                <div className="t-col header-content-container t-responsive">
                    <img className="t-logo" src= { CCLogoIcon } alt="Care Concierge"/>
                </div>
            
                {
                    /* Address */
                }
                {/* <div className="t-col t-header-content-container t-responsive">
                    <div className="t-row">
                        My Care Concierge Sdn Bhd <span>1165765-P</span>
                    </div>
                    <div className="t-row">
                        A-1-2, Block A, Jaya One,
                    </div>
                    <div className="t-row">
                        No. 72A, Jalan Professor Diraja Ungku Aziz, 
                    </div>
                    <div className="t-row">
                        46200 Petaling Jaya, Selangor, Malaysia
                    </div>
                </div>
            
                <div className="t-col t-header-content-container t-responsive">
                    <div className="t-row">
                        Careline: 1 300 22 88 22
                    </div>
                    <div className="t-row">
                        Whatsapp: +603 2724 3828
                    </div>
                    <div className="t-row">
                        www.mycareconcierge.com
                    </div>
                    <div className="t-row">
                        <img  className="t-icon" src={FBLogoIcon} alt="Facebook"/>
                        <span>
                            <img className="t-icon" src={InstaLogoIcon} alt="Instagram"/>
                        </span>
                        <span className="t-icon-text">careconcierge</span>
                    </div>
                </div> */}
            </div>
            {/* <Divider /> */}
        </div>
        
    )
}

export default Header;
